import { render } from "./LoadingVetUserReview.vue?vue&type=template&id=0a167820&scoped=true&ts=true"
import script from "./LoadingVetUserReview.vue?vue&type=script&lang=ts"
export * from "./LoadingVetUserReview.vue?vue&type=script&lang=ts"

import "./LoadingVetUserReview.vue?vue&type=style&index=0&id=0a167820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a167820"]])

export default __exports__